
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11209_7931)"}},[_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#4EC382"}}),_c('path',{attrs:{"d":"M5.83 6.105l-1.839.502a.836.836 0 00-.614.806c0 5.17 4.191 9.36 9.36 9.36.376 0 .707-.25.807-.614l.501-1.838a.834.834 0 00-.485-.99l-2.005-.837a.84.84 0 00-.97.243l-.844 1.028a7.035 7.035 0 01-3.355-3.356l1.032-.844a.84.84 0 00.242-.97L6.824 6.59a.836.836 0 00-.99-.485H5.83z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.501 5.218a.501.501 0 01.555-.05l.072.05.022.017.127.14a.474.474 0 01.056.609l-.059.073-3.19 3.19a.49.49 0 01-.592.065l-.082-.066-1.266-1.265c-.167-.167-.215-.481-.003-.683l.109-.118.02-.021.02-.017.072-.048a.501.501 0 01.483 0l.072.048.015.013.814.813 2.74-2.738.015-.013z","fill":"#fff","stroke":"#fff","stroke-width":".3"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11209_7931"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    